import React, { useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { getExchangeRateText, shouldConvertCurrency } from '../utils/currencyUtils';

const ExchangeRateTooltip = ({ locale = null, style = {} }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  // Add CSS for fadeIn animation
  React.useEffect(() => {
    if (!document.getElementById('exchange-rate-tooltip-styles')) {
      const style = document.createElement('style');
      style.id = 'exchange-rate-tooltip-styles';
      style.textContent = `
        @keyframes fadeIn {
          from { opacity: 0; transform: translateX(-50%) translateY(5px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);
  
  // Don't show tooltip for Czech locale (no conversion needed)
  if (!shouldConvertCurrency(locale)) {
    return null;
  }
  
  const exchangeRateText = getExchangeRateText(locale);
  
  return (
    <span 
      style={{ 
        position: 'relative', 
        display: 'inline-block',
        marginLeft: '5px',
        ...style 
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <FaQuestionCircle 
        style={{ 
          fontSize: '11px', 
          color: 'rgba(255, 255, 255, 0.6)',
          cursor: 'help',
          transition: 'color 0.2s ease'
        }} 
        onMouseEnter={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.9)'}
        onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.6)'}
      />
      
      {showTooltip && (
        <div style={{
          position: 'absolute',
          bottom: '130%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: 'normal',
          whiteSpace: 'nowrap',
          zIndex: 1000,
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
          animation: 'fadeIn 0.2s ease-in'
        }}>
          {exchangeRateText}
          
          {/* Triangle pointer */}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid rgba(0, 0, 0, 0.95)'
          }} />
        </div>
      )}
    </span>
  );
};

export default ExchangeRateTooltip;
